import type { Components } from '@mui/material/styles';

export default function MuiSnackbar(): Components['MuiSnackbar'] {
  return {};
}
